import React from "react";
import { motion } from "framer-motion";
import { FaThumbtack } from "react-icons/fa6";
import { FaPeopleGroup } from "react-icons/fa6";
import { HiOutlineGlobeAsiaAustralia } from "react-icons/hi2";
import { LuClipboardCheck } from "react-icons/lu";
import "../styles/ImpactSection.css";

const stats = [
  {
    icon: <LuClipboardCheck />,
    number: "Need strategy?",
    label: "Work with Nexa Partners",
  },
  {
    icon: <FaPeopleGroup />,
    number: "Building a startup?",
    label: " Join Nexa Accelerate",
  },
  {
    icon: <HiOutlineGlobeAsiaAustralia />,
    number: "Need visibility? ",
    label: "Elevate with Nexa Elevate",
  },
];

export default function ImpactSection() {
  return (
    <section className="impact-section">
      <h2 className="impact-section-h2">
        Our <span className="highlight"> Approach</span>
      </h2>
      <p className="impact-subtext">
        We combine local insight with global strategy, using data, design, and
        practical execution to deliver results. From ideation to implementation
        — we walk the journey with you.{" "}
      </p>
      <div className="grow-section">
        <h2 className="impact-section-h2">
          <span className="highlight">Let’s Grow</span> Together
        </h2>
        <p className="impact-subtext">
          Join a growing community of change-makers, startups, and
          forward-thinking institutions who trust NexaGrowth to unlock new
          levels of growth, innovation, and impact.
        </p>
      </div>
      <div className="impact-stats">
        {stats.map((item, index) => (
          <motion.div
            key={index}
            className="impact-card"
            whileHover={{ scale: 1.05 }}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            viewport={{ once: true }}
          >
            <div className="icon-wrapper">{item.icon}</div>
            <h3>{item.number}</h3>
            <p>{item.label}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
